import {
  ToolQuantity,
  ToolUnit,
  ToolReason,
  ToolName,
  ToolCode,
} from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type RecallToolTemplate = {
  ToolName: string;
  ToolCode: string;
  ToolUnit: string;
  ToolQuantity: string;
  ToolReason:string;
};

export const recallToolTemplate: TemplatesValue<RecallToolTemplate> = {
  fileName: "DanhSachThuHoiDungCu",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    ToolName,
    ToolCode,
    ToolUnit,
    ToolQuantity,
    ToolReason,
  ],
  fields: [
    "ToolName",
    "ToolCode",
    "ToolUnit",
    "ToolQuantity",
    "ToolReason",
  ],
};
